module.exports = __webpack_public_path__ + "assets/img/avatar-s-2.da5e73c7.jpg";